import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=15c156da&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c156da')) {
      api.createRecord('15c156da', component.options)
    } else {
      api.reload('15c156da', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=15c156da&", function () {
      api.rerender('15c156da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xETtb8O3pxFO/JS/videoIframe.vue"
export default component.exports